export default __webpack_public_path__ + "static/media/home-service.740196ec.PNG";